module.exports = __webpack_public_path__ + "img/area-part4-111.c7405254.png";